export default defineNuxtRouteMiddleware((to) => {
	const { isMobile } = useDevice();

	if (isMobile && to.name === "index") {
		abortNavigation();

		return navigateTo("/shop");
	}
});
